$(function () {
  if (!$.cookie("notice-accepted")) {
//     $("#dialog-modal").dialog({
//       height: 380,
//       width: 500,
//       modal: true,
//       buttons: {
//         Ok: function () {
//           $.cookie("notice-accepted", 1, { expires : 30 });
//           $(this).dialog("close");
//         }
//       }
//     });

    $.fancybox.open([
      {
        src: '#newsletter_popup',
        opts : {
          afterClose : function( instance, current ) {
            $.cookie("notice-accepted", 1, { expires : 30 });
            console.info( 'done!' );
          }
        }
      }
    ]);
  }
});



$(document).ready(function(){
  $("#start-quiz-btn").click(function(){
    $(".start-quiz-wrapper").hide();
    $("#msform").fadeIn();
  });
});